export default __webpack_public_path__ + "static/media/share.aabc16a2.png";